import axiosIns from '@/libs/axios'
import utilsService from './utilsService'

const controller = 'pesquisador'

export default {
  async getAll(filter) {
    const cleanFilter = utilsService.cleanObject(filter)
    const response = await axiosIns.get(`${controller}?${utilsService.getQueryParams(cleanFilter)}`)
    return response.data
  },

  async getById(id) {
    const response = await axiosIns.get(`${controller}/${id}`)
    return response.data
  },

  async create(req) {
    const response = await axiosIns.post(controller, req)
    console.log(response)
    return response.data
  },

  async update(req) {
    const response = await axiosIns.put(controller, req)
    return response.data
  },

  async delete(id) {
    const response = await axiosIns.delete(`${controller}/${id}`)
    return response.data
  },
}
